import * as React from 'react';

export interface ITabListTabContentProps {
  id?: string;
  navId?: string;
  index?: number;
  activeIndex?: number;
  children: React.ReactNode;
}

function TabListTabContent({ id = undefined, navId = undefined, index = undefined, activeIndex = undefined, children }: ITabListTabContentProps) {
  return (
    <div id={id} className={`tab-pane ${index === activeIndex ? 'active' : ''}`} role="tabpanel" aria-labelledby={navId} tabIndex={0}>
      {children}
    </div>
  );
}

export default TabListTabContent;
